import ChatThreadExchangeAssistantSlot from './ChatThreadExchangeAssistantSlot.jsx'
import ChatThreadExchangeQuestion from './ChatThreadExchangeQuestion.jsx'

export default function ChatThreadExchangeRowBody(props) {
  return (
    <>
      <ChatThreadExchangeQuestion {...props} />
      <ChatThreadExchangeAssistantSlot {...props} />
    </>
  )
}
